import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { AuthModalProps } from './AuthModal.types';

export const renderAuthModalDialog = (data: AuthModalProps = {}) => openPopupHelper({ popupName: popupNames.AUTH_MODAL, data });
